import React from 'react';
/*
  I've decided to avoid createContexts here because its "useContext" hook forces the user declare Provider if it is not required
 */
const useRequestContext = React.createContext({});
export const UseRequestProvider = useRequestContext.Provider;
export const useRequestContextValue = () => React.useContext(useRequestContext);
